import React, { useLayoutEffect, useRef, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";

export default function ItemDescription({ description, itemName, label }) {
  const previewRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const dialogTitle = `${itemName} — ${label}`;

  useLayoutEffect(() => {
    const preview = previewRef.current;
    const updateTruncation = () => {
      setIsTruncated(
        preview.scrollHeight > preview.clientHeight ||
          preview.scrollWidth > preview.clientWidth,
      );
    };

    updateTruncation();

    if (typeof ResizeObserver !== "undefined") {
      const observer = new ResizeObserver(updateTruncation);
      observer.observe(preview);
      return () => observer.disconnect();
    }

    window.addEventListener("resize", updateTruncation);
    return () => window.removeEventListener("resize", updateTruncation);
  }, [description]);

  const closeDialog = () => setIsOpen(false);

  return (
    <div className="Marketplace-Item-Description">
      <p ref={previewRef} className="Item-Description-Marketplace">
        {description}
      </p>
      {isTruncated && (
        <button
          type="button"
          className="Marketplace-Description-See-More"
          aria-label={`See more: ${dialogTitle}`}
          aria-haspopup="dialog"
          onClick={() => setIsOpen(true)}
        >
          See more
        </button>
      )}
      <Dialog
        className="Marketplace-Description-Dialog"
        open={isOpen}
        onClose={closeDialog}
        PaperProps={{ "aria-label": dialogTitle }}
        disableScrollLock
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>{dialogTitle}</DialogTitle>
        <DialogContent dividers>
          <p className="Marketplace-Description-Full">{description}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog} color="primary" autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
